import "./css/style.scss";
import Reveal from "./Components/Reveal.jsx";
import Slider from "react-infinite-logo-slider";

export default function Clients({ content }) {
  const shuffle = (array) => {
    let shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      if (shuffled[i].keepPosition || shuffled[j].keepPosition) {
        continue;
      }
      const temp = shuffled[i];
      shuffled[i] = shuffled[j];
      shuffled[j] = temp;
    }
    const cut = Math.floor(Math.random() * shuffled.length);
    shuffled = [...shuffled.slice(cut), ...shuffled.slice(0, cut)];
    return shuffled;
  };

  const shuffledContent = [shuffle(content), shuffle(content), shuffle(content)];

  return (
    <section id="clients">
      <Reveal delay={0.2}>
        <div className="section-title">Clients</div>
      </Reveal>

      <div className="clients">
        <div className="overlay" />
        <Reveal delay={0.4}>
          <Slider width="20rem" duration={120}>
            {shuffledContent[0].map((item, i) => (
              <Slider.Slide key={i}>
                <div className="logo">
                  <img src={item.logoSrc} alt={item.name} />
                </div>
              </Slider.Slide>
            ))}
          </Slider>
        </Reveal>
        <Reveal delay={0.5}>
          <Slider width="20rem" duration={30}>
            {shuffledContent[1].map((item, i) => (
              <Slider.Slide key={i}>
                <div className="logo">
                  <img src={item.logoSrc} alt={item.name} />
                </div>
              </Slider.Slide>
            ))}
          </Slider>
        </Reveal>
        <Reveal delay={0.6}>
          <Slider width="20rem" duration={60}>
            {shuffledContent[2].map((item, i) => (
              <Slider.Slide key={i}>
                <div className="logo">
                  <img src={item.logoSrc} alt={item.name} />
                </div>
              </Slider.Slide>
            ))}
          </Slider>
        </Reveal>
      </div>
    </section>
  );
}
